const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/modules/CIS4m/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        ja: 'Ja',
        nein: 'Nein',
        keineAngabe: 'Keine Angabe',
    },
    __RELATIVE_SOURCE_FILE__
);
